module.exports = __webpack_public_path__ + "img/x5.4f455e87.png";